// @flow

import * as React from 'react';

import clsx from 'clsx';

import styles from './Main.scss';

export type Props = {
  children?: React.Node,
  className?: string,
};

export function Main({ children, className }: Props): React.MixedElement {
  return (
    <main id="layout-main-content" className={clsx(styles.root, className)}>
      {children}
    </main>
  );
}
